import { render } from "./ResultsPanel.vue?vue&type=template&id=142cc1a0&scoped=true"
import script from "./ResultsPanel.vue?vue&type=script&lang=js"
export * from "./ResultsPanel.vue?vue&type=script&lang=js"

import "./ResultsPanel.vue?vue&type=style&index=0&id=142cc1a0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142cc1a0"]])

export default __exports__